const routes = [
  {
    path: '/',
    redirect: '/home',
    component: _ => import('@/page/layout/main.vue'),
    name: 'Main',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: _ => import('@/page/home/index.vue')
      },
      {
        path: 'introduction/healthKY',
        name: 'HealthKY',
        component: _ => import('@/page/introduction/healthKY/index.vue')
      },
      {
        path: 'introduction/chronic',
        name: 'ChronicDisease',
        component: _ => import('@/page/introduction/chronic/index.vue')
      },
      {
        path: 'solutions/institutions',
        name: 'Institutions',
        component: _ => import('@/page/solution/institutions.vue')
      },
      {
        path: 'solutions/community',
        name: 'Community',
        component: _ => import('@/page/solution/community.vue')
      },
      {
        path: 'solutions/household',
        name: 'Household',
        component: _ => import('@/page/solution/household.vue')
      },
      {
        path: 'news',
        name: 'News',
        component: _ => import('@/page/news/list.vue')
      },
      {
        path:'news/detail',
        name: 'newDetail',
        component: _ => import('@/page/news/detail.vue')
      },
      {
        path: 'about',
        name: 'About',
        component: _ => import('@/page/about/index.vue')
      },
    ]
  }
]

export default routes


// WEBPACK FOOTER //
// ./src/router/routes.js